<template>
  <ItemDialog ref="dialogRef" image-type="done" :initial-open="false">
    <template #content-area>
      <h2>予約をキャンセルしました</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="戻る"
        action-type="btn-cancel"
        @clicked="ncDemandClose()"
      />
    </template>
  </ItemDialog>
</template>
<script>
import { ref } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DialogCancelComplete",
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    const ncDemandClose = async () => {
      nativeHandlerService.demand.ncDemandClose();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
      ncDemandClose,
    };
  },
};
</script>
